import Vue from 'vue'

import {
  TabsPlugin,
  LayoutPlugin,
  AlertPlugin,
  BadgePlugin,
  ButtonPlugin,
  CardPlugin,
  FormPlugin,
  FormInputPlugin,
  FormGroupPlugin,
  FormRadioPlugin,
  FormSelectPlugin,
  FormTextareaPlugin,
  FormCheckboxPlugin,
  InputGroupPlugin,
  ImagePlugin,
  NavbarPlugin,
  ModalPlugin,
  TablePlugin,
  PaginationPlugin,
  ListGroupPlugin,
  TooltipPlugin,
  FormFilePlugin,
} from 'bootstrap-vue'

Vue.use(TabsPlugin)
Vue.use(LayoutPlugin)
Vue.use(AlertPlugin)
Vue.use(BadgePlugin)
Vue.use(ButtonPlugin)
Vue.use(CardPlugin)
Vue.use(FormPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormRadioPlugin)
Vue.use(FormSelectPlugin)
Vue.use(FormTextareaPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(InputGroupPlugin)
Vue.use(ImagePlugin)
Vue.use(NavbarPlugin)
Vue.use(ModalPlugin)
Vue.use(TablePlugin)
Vue.use(PaginationPlugin)
Vue.use(ListGroupPlugin)
Vue.use(TooltipPlugin)
Vue.use(FormFilePlugin)
